<script setup lang="ts">
import tokenService from "@/common/services/TokenService"
import { ref } from "vue"
import RequestPopup from "@/apps/recruiter/components/RequestPopup.vue"
import { useRouter } from "vue-router"
import logo from "@/common/assets/study-buddy-logo.svg"
import gigaCode from "@/common/assets/giga-code.svg"
import route from "@/apps/recruiter/router/route"
import { useUser } from "@/common/store"
import manual from "@/apps/recruiter/assets/recruiter-manual.pdf"
import manualEvent from "@/apps/recruiter/assets/event-recruiter-manual.pdf"
import manualHr from "@/apps/recruiter/assets/personnel-officer-manual.pdf"
import HelpDialog from "@/common/dialogs/HelpDialog.vue"

const router = useRouter()
const userStore = useUser()
const requestPopupOpen = ref<boolean>(false)
const helpDialogOpen = ref<boolean>(false)

const logout = async () => {
    tokenService.removeTokens()
    await router.replace({ name: route.login.name })
}

const chooseManual = () => {
    switch (userStore.getUser().type) {
        case "recruiter":
            return manual
        case "event-recruiter":
            return manualEvent
        case "personnel_officer":
            return manualHr
        default:
            return undefined
    }
}
</script>

<template>
    <q-layout view="hHh lpR fFf" class="bg-dark-page column">
        <q-header bordered class="bg-primary">
            <q-toolbar>
                <q-btn flat round dense icon="menu" />
                <q-toolbar-title style="font-size: 190%" class="row items-center">
                    <a href="https://studdybuddy.ru/" class="flex">
                        <img :src="logo" alt="StuddyBuddy" class="full-height" />
                    </a>
                    <a href="https://gigacode.ru" target="_blank" class="flex">
                        <img :src="gigaCode" alt="GigaCode" height="25" class="q-ml-lg" />
                    </a>
                </q-toolbar-title>
                <div class="row items-center justify-end">
                    <div v-if="userStore.getUser()?.contactBalance !== undefined">
                        <q-icon name="o_contact_mail" size="md" />
                        <span class="text-subtitle1 q-px-sm">{{
                            userStore.getUser().contactBalance
                        }}</span>
                    </div>
                    <div>
                        <q-btn icon="mail" flat @click="requestPopupOpen = true" />
                    </div>
                    <div class="text-subtitle1 q-mx-md">
                        {{ userStore.getUser().email }}
                    </div>
                    <div>
                        <q-btn
                            outline
                            size="sm"
                            label="Помощь"
                            class="q-mx-md"
                            @click="helpDialogOpen = true"
                        />
                        <q-btn icon="logout" flat @click="logout" />
                    </div>
                </div>
            </q-toolbar>
        </q-header>

        <q-page-container class="col-grow column">
            <RouterView />
            <HelpDialog v-model="helpDialogOpen" :file-download-link="chooseManual()" />
        </q-page-container>
    </q-layout>
    <RequestPopup v-model="requestPopupOpen" />
</template>

<style scoped></style>
